import React, { useState, useEffect, useContext } from "react";
import ReusableModal from "../ManageSettings/ReusableModal";
import "./Gas.css";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import SettingTable from "../ManageSettings/SettingTable";
import AuthContext from "../../../../utils/secure-route/AuthContext";
import { ToastContainer } from "react-toastify";
import useSwal from '../../../common/ReusableComponent/useSwal'
import invoiceIcon from "../../../../assets/Image/invoiceIcon.png";
import { useToastHandler } from '../../../common/ToastHandler'
import { CustomButton, RegularButton } from "../../../common/ReusableComponent/CustomButton";
import { ReusableInput } from "../../../common/ReusableComponent/ReusableInput";
import CustomDateInput from "../../../../context/CustomDateInput";
import useFormattingUtils from "../../../../context/useFormattingUtils";
import ReusableTable from "../../../common/ReusableComponent/reusableTable/ReusableTable";
function GasInvoice() {
  const [gas, setGas] = useState([]);
  const [reloadData, setReloadData] = useState(false);
  const { user } = useContext(AuthContext);
  const storeid = user.store;
  const { Post, Delete, _Get, getAPI , GetPaginatedData} = useApi();
  const [showGasModal, setShowGasModal] = useState(false);
  const handleShowGas = () => setShowGasModal(true);
  const handleCloseGas = () => {
    setShowGasModal(false);
    resetForm();
  };
  const [loading, setLoading] = useState(false);
  const { handleToast } = useToastHandler()
  const { confirmDelete } = useSwal()

  const { formatDate } = useFormattingUtils()
  const handleOnDelete = async (id) => {
    const result = await confirmDelete()

    if (!result.isConfirmed) return;
    await Delete("gasInvoiceData", id)
      .then((resp) => {
        setReloadData(!reloadData);

        handleToast({
          type: "SUCCESS",
          message: 'Gas invoice removed.'
        })
      })
      .catch((err) => {

        handleToast({
          type: "ERROR",
          message: 'Something went wrong.'
        })
      });
  };
  const [formData, setFormData] = useState({
    date: new Date().toISOString().split('T')[0],
    invoice_no: "",
    freight_diesel_gross_units: "",
    freight_diesel_unit_price: "",
    freight_diesel_total: "",
    freight_gas_gross_units: "",
    freight_gas_unit_price: "",
    freight_gas_total: "",
    freight_both_gross_units: "",
    freight_both_unit_price: "",
    freight_both_total: "",
    minimum_load_penalty: "",
    misc_cost: "",
    invoice_total: "",
  });
  const [gasTypes, setGasTypes] = useState([]);
  const [gasFreights, setGasFreights] = useState([]);
  const [gasTaxes, setGasTaxes] = useState([]);

  const [myJson, setMyJson] = useState({});

  const [freightGrossUnits, setFreightGrossUnits] = useState({
    all: 0,
    diesel: 0,
    withOutDiesel: 0,
  });

  const [generalTotalObj, setGeneralTotalObj] = useState({});
  const [generalTotalObjFre, setGeneralTotalObjFre] = useState({});
  const [generalTotalObjTax, setGeneralTotalObjTax] = useState({});
  const updateGeneralTotal = (type, value) => {
    setGeneralTotalObj((prev) => ({ ...prev, [type]: value }));
  };

  const updateTaxTotal = (type, value) => {
    setGeneralTotalObjTax((prev) => ({ ...prev, [type]: value }));
  };

  const [finalTotal, setFinalTotal] = useState(0);

  const [dateError, setDateError] = useState("");

  useEffect(() => {
    fetchGasData();
    fetchInvoiceValues();
    settle();
  }, [reloadData]);

  useEffect(() => {
    settle();
  }, [myJson, generalTotalObj, finalTotal]);

  const handleDateChange = (e) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      date: value,
    }));
  };

  function groupAndSum(data) {
    const result = { all: 0 };
    for (const [key, value] of Object.entries(data)) {
      const [prefix] = key.split("_");
      if (result[prefix]) {
        result[prefix] += value;
      } else {
        result[prefix] = value;
      }
      result.all += value;
    }
    return result;
  }
const fetchGasData = async ({ page = 1, searchTerm = "" } = {}) => {
  try {
    setLoading(true);

    const response = await GetPaginatedData("gasInvoiceData", {
      page,
      search: searchTerm,
    });

    const results = response?.data || [];
    const count = response?.totalCount || 0;
    const totalPages = Math.ceil(count / 10);

    const formatted = results.map((item) => ({
      ...item,
      date: item.date ? formatDate(item.date) : "N/A",
    }));

    setGas(formatted);
    return { data: formatted, totalPages };
  } catch (error) {
    console.error("Error fetching gas data:", error);
    handleToast({
      type: "ERROR",
      message: "Failed to fetch gas invoice data.",
    });
    setGas([]);
    return { data: [], totalPages: 1 };
  } finally {
    setLoading(false);
  }
};




  const handleOnUpdate = () => { };

  const fetchInvoiceValues = async () => {
    await _Get("getValuesForInvoice")
      .then((response) => {
        if (response.gas_types) {
          setGasTypes(response.gas_types);
          setFormData((prevData) => {
            const updatedData = { ...prevData };
            response.gas_types.forEach((gasType) => {
              const fieldName = `gas_${gasType.gas_type_title.toLowerCase()}_unit_price`;
              updatedData[fieldName] = gasType.cost_per_gallon || "";
            });

            return updatedData;
          });
        }

        if (response.gas_freights) {
          setGasFreights(response.gas_freights);
          setFormData((prevData) => {
            const updatedData = { ...prevData };
            response.gas_freights.forEach((freight) => {
              const fieldName = `freight_${freight.freight_name.toLowerCase()}_unit_price`;
              updatedData[fieldName] = freight.freight_value || "";
            });

            return updatedData;
          });
        }

        if (response.gas_taxes) {
          setGasTaxes(response.gas_taxes);
          setFormData((prevData) => {
            const updatedData = { ...prevData };
            response.gas_taxes.forEach((tax) => {
              updatedData[`${tax.tax_name.toLowerCase()}_basic`] = "";
              updatedData[`${tax.tax_name.toLowerCase()}_rate`] = "";
              updatedData[`${tax.tax_name.toLowerCase()}_total`] = "0.00";
            });

            return updatedData;
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching invoice values:", error);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: value };

      const gasTypeMatch = name.match(/gas_(.*)_unit_price/);
      if (gasTypeMatch) {
        const gasType = gasTypeMatch[1];
        const newUnitPrice = parseFloat(value);

        const grossUnit = gasGrossUnits[gasType] || 0;
        const newTotal = newUnitPrice * grossUnit;

        updatedData[`gas_${gasType}_total`] = newTotal;

        updateGeneralTotal(`gas_${gasType}`, newTotal);
      }

      return updatedData;
    });

    settle();
  };

  const calculateInvoiceTotal = (data) => {
    let total = 0;

    gasTypes.forEach((gasType) => {
      const type = gasType.gas_type_title.toLowerCase();
      const gasTotal = Number(data[`gas_${type}_total`] || 0);

      total += gasTotal;
    });

    gasFreights.forEach((freight) => {
      const type = freight.freight_name.toLowerCase();
      const freightTotal = Number(data[`freight_${type}_total`] || 0);

      total += freightTotal;
    });

    gasTaxes.forEach((tax) => {
      const taxTotal = Number(data[`${tax.tax_name.toLowerCase()}_total`] || 0);

      total += taxTotal;
    });

    total += Number(data.minimum_load_penalty || 0);
    total += Number(data.misc_cost || 0);

    return total;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.date) {
      handleToast({
        type: "ERROR",
        message: "Please select a date."
      });
      return;
    }
    if (!formData.invoice_no || formData.invoice_no.trim() === "") {
      handleToast({
        type: "ERROR",
        message: "Please enter an invoice number."
      });
      return;
    }
    const dieselGrossUnitTotal =
      freightGrossUnits.freight_diesel *
      (formData.freight_diesel_unit_price || 0);
    const gasGrossUnitTotal =
      freightGrossUnits.freight_withOutDiesel *
      (formData.freight_gas_unit_price || 0);
    const bothGrossUnitTotal =
      freightGrossUnits.freight_all * (formData.freight_both_unit_price || 0);

    const invoiceTotal = Number(finalTotal) + Number(minLoadCap) + Number(miscCost);
    
    // Validate invoice total doesn't exceed 8 digits before decimal
    if (invoiceTotal >= 100000000) {
      handleToast({
        type: "ERROR",
        message: "Invoice total cannot exceed 8 digits before the decimal point."
      });
      return;
    }

    const updatedFormData = {
      ...formData,
      store: storeid,
      freight_diesel_gross_units: freightGrossUnits.freight_diesel,
      freight_diesel_total: dieselGrossUnitTotal.toFixed(2),
      freight_gas_gross_units: freightGrossUnits.freight_withOutDiesel,
      freight_gas_total: gasGrossUnitTotal.toFixed(2),
      freight_both_gross_units: freightGrossUnits.freight_all,
      freight_both_total: bothGrossUnitTotal.toFixed(2),
      minimum_load_penalty: Number(minLoadCap),
      misc_cost: Number(miscCost),
      invoice_total: Number(finalTotal) + Number(minLoadCap) + Number(miscCost),
    };

    Post("gasInvoiceData", updatedFormData)
      .then((response) => {
        setReloadData(!reloadData);
        resetForm();
        handleCloseGas();
        handleToast({
          type: "SUCCESS",
          message: "Gas Invoice Created successfully"
        })
      })
      .catch((error) => {
        console.error("Error posting gas data:", error);
        
        let errorMessage = "Error saving gas invoice data.";
        
        if (error.response?.data) {
          if (error.response.data.invoice_total) {
            errorMessage = error.response.data.invoice_total[0];
          } else if (error.response.data.non_field_errors) {
            errorMessage = error.response.data.non_field_errors[0];
          } else if (typeof error.response.data === 'string') {
            errorMessage = error.response.data;
          } else {
            errorMessage = JSON.stringify(error.response.data);
          }
        }
        
        handleToast({
          type: "ERROR",
          message: errorMessage
        });
      });
  };

  const [gasGrossUnits, setGasGrossUnits] = useState({});

  const calculateTotals = (data) => {
    let totalOnlyDiesel = 0;
    let totalWithoutDiesel = 0;
    let totalWithDiesel = 0;

    for (const [key, value] of Object.entries(data)) {
      if (key === "diesel") {
        totalOnlyDiesel = value;
      } else {
        totalWithoutDiesel += value;
      }

      totalWithDiesel += value;
    }

    setGeneralTotalObjFre({
      freight_diesel: formData.freight_diesel_unit_price * totalOnlyDiesel,
      freight_gas: formData.freight_gas_unit_price * totalWithoutDiesel,
      freight_both: formData.freight_both_unit_price * totalWithDiesel,
    });
    gasTaxes.map((tax, index) => {
      let type = tax.gas_type;
      const grossUnit =
        type === "both"
          ? freightGrossUnits.freight_all
          : type === "diesel"
            ? freightGrossUnits.freight_diesel
            : type === "gas"
              ? freightGrossUnits.freight_withOutDiesel
              : 0;

      const rate =
        formData[`${tax.tax_name.toLowerCase()}_rate`] || tax.tax_value;

      updateTaxTotal(`gasTax_${type}`, grossUnit * rate);
    });

    setFreightGrossUnits({
      freight_all: totalWithDiesel,
      freight_diesel: totalOnlyDiesel,
      freight_withOutDiesel: totalWithoutDiesel,
    });

    return [
      { label: "diesel", total: totalOnlyDiesel },
      { label: "withOutDiesel", total: totalWithoutDiesel },
      { label: "all", total: totalWithDiesel },
    ];
  };

  const settle = () => {
    calculateTotals(myJson);
    let obj = {
      gasTotal: groupAndSum(generalTotalObj).all,
      freight: groupAndSum(generalTotalObjFre).all,
      tax: groupAndSum(generalTotalObjTax).all,
    };

    setFinalTotal(groupAndSum(obj).all);
  };

  const handleGrossUnitChange = async (e, gasType) => {
    let newGrossUnit = e.target.value;

    if (newGrossUnit === "" || /^\d{1,8}(\.\d{0,2})?$/.test(newGrossUnit)) {
      const numericValue = newGrossUnit === "" ? 0 : parseFloat(newGrossUnit);

      formData[`gas_${gasType}_total`] =
        formData[`gas_${gasType}_unit_price`] * numericValue;

      updateGeneralTotal(
        "gas_" + gasType,
        formData[`gas_${gasType}_unit_price`] * numericValue
      );

      await updateGrossUnit(newGrossUnit === "" ? "" : numericValue, gasType);

      setMyJson((prev) => ({
        ...prev,
        [gasType]: numericValue,
      }));

      settle(myJson);
    }
  };

  const updateGrossUnit = async (newGrossUnit, gasType) => {
    setGasGrossUnits((prev) => ({
      ...prev,
      [gasType]: newGrossUnit,
    }));
  };




  const columns = [
    { header: "Purchase Date", field: "date" },
    { header: "Invoice no", field: "invoice_no" },
    { header: "Total Gas Gallons", field: "freight_gas_gross_units" },
    { header: "Total Diesel Gallons", field: "freight_diesel_gross_units" },
    { header: "Amount", field: "invoice_total" },
  ];
  const [minLoadCap, setMinLoadCap] = useState(0);
  const [miscCost, setMiscCost] = useState(0);

  const resetForm = () => {
    setFormData({
      date: new Date().toISOString().split('T')[0],
      invoice_no: "",
      freight_diesel_gross_units: "",
      freight_diesel_unit_price: "",
      freight_diesel_total: "",
      freight_gas_gross_units: "",
      freight_gas_unit_price: "",
      freight_gas_total: "",
      freight_both_gross_units: "",
      freight_both_unit_price: "",
      freight_both_total: "",
      minimum_load_penalty: "",
      misc_cost: "",
      invoice_total: "",
    });
    setGasGrossUnits({});
    setMyJson({});
    setMinLoadCap(0);
    setMiscCost(0);
    setGeneralTotalObj({});
    setGeneralTotalObjFre({});
    setGeneralTotalObjTax({});
    setFinalTotal(0);
  };
  return (
    <>
      <ToastContainer />
      <div className="responsive-box">
        <div className="header-row">
          <div className="setting-title">Gas Invoice</div>
          <div
            className="btn-position"
            style={{ display: "flex", gap: "10px" }}
          >
            <CustomButton
              text="Add Invoice"
              icon={invoiceIcon}
              onClick={handleShowGas}
              color="#000000"
              backgroundColor="#FFAF32"
              iconPosition="right"
            />
          </div>
        </div>
        <ReusableModal
          show={showGasModal}
          handleClose={handleCloseGas}
          title={"Add Invoice"}
          width="927px"
          height="auto"
        >
          <form onSubmit={handleSubmit}>
            <div className="">
              <div className="d-flex align-items-center mb-0">
                {/* <input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleDateChange}
                  className="form-control-borderless"
                  placeholder="dates"
                  style={{
                    width: "160px",
                    marginLeft: "10px",
                    height: "44px",
                  }}
                /> */}
                <CustomDateInput
                  name="date"
                  value={formData.date}
                  onChange={handleDateChange}
                  placeholder="Select Date"
                  inputStyle={{

                    width: "200px",
                    marginLeft: "10px",
                    height: "44px",



                  }}
                />

                <div style={{ marginTop: "20px", marginLeft: "20px" }}>
                  <ReusableInput
                    type="text"
                    name="invoice_no"
                    label="Invoice No"
                    placeholder=""
                    value={formData.invoice_no}
                    onChange={handleChange}
                    width={"300px"}
                  />
                </div>
              </div>

              <div className="  mt-3">
                <div
                  className="table"
                  style={{
                    borderLeft: "1px solid #EBEAF2",
                    borderRight: "1px solid #EBEAF2",
                  }}
                >
                  <table
                    className="table table-borderless table-responsive"
                    style={{
                      justifyContent: "center",
                      textAlign: "center",
                      borderRadius: "none",
                    }}
                  >
                    <thead>
                      <tr style={{ justifyContent: "left", textAlign: "left" }}>
                        <th>Description</th>
                        <th>Gross Units</th>
                        <th>Unit Price</th>
                        <th>Total</th>
                      </tr>
                    </thead>

                    <tbody>
                      {gasTypes.map((gasType, index) => {
                        const type = gasType.gas_type_title.toLowerCase();
                        return (
                          <tr key={index}>
                            <td
                              style={{
                                justifyContent: "left",
                                textAlign: "left",
                              }}
                            >
                              {gasType.gas_type_title}
                            </td>
                            <td
                              style={{
                                justifyContent: "left",
                                textAlign: "left",
                              }}
                            >
                              <input
                                type="number"
                                value={gasGrossUnits[type] || ""}
                                onChange={(e) => handleGrossUnitChange(e, type)}
                                className="input-select"
                                style={{ width: "150px", height: "36px" }}
                              />
                            </td>
                            <td
                              style={{
                                justifyContent: "left",
                                textAlign: "left",
                              }}
                            >
                              <input
                                type="text"
                                name={`gas_${type}_unit_price`}
                                value={formData[`gas_${type}_unit_price`] || ""}
                                onChange={handleChange}
                                className="input-select"
                                style={{ width: "110px", height: "36px" }}
                              />
                            </td>
                            <td
                              style={{
                                justifyContent: "left",
                                textAlign: "left",
                              }}
                            >
                              {formData[`gas_${type}_total`] ||
                                gasGrossUnits[type] *
                                formData[`gas_${type}_unit_price`] ||
                                "0.00"}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className=" mt-3">
                <div
                  className="table"
                  style={{
                    borderLeft: "1px solid #EBEAF2",
                    borderRight: "1px solid #EBEAF2",
                  }}
                >
                  <table
                    className="table table-borderless table-responsive"
                    style={{
                      justifyContent: "center",
                      textAlign: "center",
                      borderRadius: "none",
                    }}
                  >
                    <thead>
                      <tr style={{ justifyContent: "left", textAlign: "left" }}>
                        <th style={{ maxWidth: "120px" }}>Freight Summary</th>
                        <th>Gross Units</th>
                        <th>Unit Price</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {gasFreights.map((freight, index) => {
                        const type = freight.freight_name.toLowerCase();
                        const freightUnitPrice =
                          formData[`freight_${type}_unit_price`] || 0;
                        const grossUnitValue =
                          type === "both"
                            ? freightGrossUnits.freight_all
                            : type === "diesel"
                              ? freightGrossUnits.freight_diesel
                              : type === "gas"
                                ? freightGrossUnits.freight_withOutDiesel
                                : 0;

                        return (
                          <tr key={index}>
                            <td
                              style={{
                                justifyContent: "left",
                                textAlign: "left",
                              }}
                            >
                              {freight.freight_name}
                            </td>
                            <td
                              style={{
                                justifyContent: "left",
                                textAlign: "left",
                              }}
                            >
                              {type === "both" ? (
                                <input
                                  type="number"
                                  value={
                                    type === "both"
                                      ? freightGrossUnits.freight_all
                                      : 0
                                  }
                                  className="input-select"
                                  style={{
                                    width: "150px",
                                    height: "36px",
                                    backgroundColor: "transparent",
                                  }}
                                  disabled
                                />
                              ) : (
                                ""
                              )}
                              {type === "diesel" ? (
                                <input
                                  type="number"
                                  value={
                                    type === "diesel"
                                      ? freightGrossUnits.freight_diesel
                                      : 0
                                  }
                                  className="input-select"
                                  style={{
                                    width: "150px",
                                    height: "36px",
                                    backgroundColor: "transparent",
                                  }}
                                  disabled
                                />
                              ) : (
                                ""
                              )}
                              {type === "gas" ? (
                                <input
                                  type="number"
                                  value={
                                    type === "gas"
                                      ? freightGrossUnits.freight_withOutDiesel
                                      : 0
                                  }
                                  className="input-select"
                                  style={{
                                    width: "150px",
                                    height: "36px",
                                    backgroundColor: "transparent",
                                  }}
                                  disabled
                                />
                              ) : (
                                ""
                              )}
                            </td>
                            <td
                              style={{
                                justifyContent: "left",
                                textAlign: "left",
                              }}
                            >
                              <input
                                type="number"
                                name={`freight_${type}_unit_price`}
                                value={
                                  formData[`freight_${type}_unit_price`] || ""
                                }
                                className="input-select"
                                style={{
                                  width: "110px",
                                  height: "36px",
                                  backgroundColor: "transparent",
                                }}
                                disabled
                              />
                            </td>
                            <td>
                              <td
                                style={{
                                  justifyContent: "left",
                                  textAlign: "left",
                                }}
                              >
                                {formData[`freight_${type}_total`] ||
                                  grossUnitValue * freightUnitPrice ||
                                  "0.00"}
                              </td>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className=" mt-3">
                <div
                  className="table"
                  style={{
                    borderLeft: "1px solid #EBEAF2",
                    borderRight: "1px solid #EBEAF2",
                  }}
                >
                  <table
                    className="table table-borderless table-responsive"
                    style={{
                      justifyContent: "left",
                      textAlign: "left",
                    }}
                  >
                    <thead>
                      <tr>
                        <th style={{ maxWidth: "120px" }}>
                          Tax & Other <br />
                          Charges Summary
                        </th>
                        <th>Basic</th>
                        <th>Rate</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {gasTaxes.map((tax, index) => {
                        let type = tax.gas_type;

                        const calculateTotal = () => {
                          const grossUnit =
                            type === "both"
                              ? freightGrossUnits.freight_all
                              : type === "diesel"
                                ? freightGrossUnits.freight_diesel
                                : type === "gas"
                                  ? freightGrossUnits.freight_withOutDiesel
                                  : 0;

                          const rate =
                            formData[`${tax.tax_name.toLowerCase()}_rate`] ||
                            tax.tax_value;

                          return grossUnit * rate;
                        };
                        return (
                          <tr key={index}>
                            <td
                              style={{
                                justifyContent: "left",
                                textAlign: "left",
                              }}
                            >
                              {tax.tax_name}
                            </td>
                            <td
                              style={{
                                justifyContent: "left",
                                textAlign: "left",
                              }}
                            >
                              {type === "both" ? (
                                <input
                                  type="number"
                                  value={
                                    type === "both"
                                      ? freightGrossUnits.freight_all
                                      : 0
                                  }
                                  className="input-select"
                                  style={{
                                    width: "150px",
                                    height: "36px",
                                    backgroundColor: "transparent",
                                  }}
                                  disabled
                                />
                              ) : (
                                ""
                              )}
                              {type === "diesel" ? (
                                <input
                                  type="number"
                                  value={
                                    type === "diesel"
                                      ? freightGrossUnits.freight_diesel
                                      : 0
                                  }
                                  className="input-select"
                                  style={{
                                    width: "150px",
                                    height: "36px",
                                    backgroundColor: "transparent",
                                  }}
                                  disabled
                                />
                              ) : (
                                ""
                              )}
                              {type === "gas" ? (
                                <input
                                  type="number"
                                  value={
                                    type === "gas"
                                      ? freightGrossUnits.freight_withOutDiesel
                                      : 0
                                  }
                                  className="input-select"
                                  style={{
                                    width: "150px",
                                    height: "36px",
                                    backgroundColor: "transparent",
                                  }}
                                  disabled
                                />
                              ) : (
                                ""
                              )}
                            </td>
                            <td
                              style={{
                                justifyContent: "left",
                                textAlign: "left",
                              }}
                            >
                              <input
                                type="text"
                                name={`${tax.tax_name.toLowerCase()}_rate`}
                                value={
                                  formData[
                                  `${tax.tax_name.toLowerCase()}_rate`
                                  ] || tax.tax_value
                                }
                                onChange={handleChange}
                                className="input-select"
                                style={{
                                  width: "110px",
                                  height: "36px",
                                  backgroundColor: "transparent",
                                }}
                                disabled
                              />
                            </td>
                            <td
                              style={{
                                justifyContent: "left",
                                textAlign: "left",
                              }}
                            >
                              {calculateTotal().toFixed(2)}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className=" card mt-3" style={{ borderRadius: "20px" }}>
                <div>
                  <table className="table">
                    <thead>
                      <tr></tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          style={{ justifyContent: "left", textAlign: "left" }}
                        >
                          Minimum Load Penalty
                        </td>
                        <td></td>
                        <td></td>
                        <td>
                          {" "}
                          <input
                            type="number"
                            name="minimum_load_penalty"
                            value={minLoadCap}
                            onChange={(e) => {
                              setMinLoadCap(e.target.value);
                            }}
                            className="input-field"
                            style={{
                              width: "110px",
                              height: "36px",
                              marginLeft: "450px",
                            }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ justifyContent: "left", textAlign: "left" }}
                        >
                          Misc Cost
                        </td>
                        <td></td>
                        <td></td>
                        <td>
                          <input
                            type="number"
                            name="misc_cost"
                            value={miscCost}
                            onChange={(e) => {
                              setMiscCost(e.target.value);
                            }}
                            className="input-field"
                            style={{
                              width: "110px",
                              height: "36px",
                              marginLeft: "450px",
                            }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ justifyContent: "left", textAlign: "left" }}
                        >
                          Invoice Total
                        </td>
                        <td></td>
                        <td></td>
                        <td>
                          <input
                            readOnly
                            type="number"
                            name="invoice_total"
                            value={
                              Math.max(
                                calculateInvoiceTotal(formData),
                                finalTotal
                              ) +
                              Number(minLoadCap) +
                              Number(miscCost)
                            }
                            onChange={handleChange}
                            className="input-field"
                            style={{
                              width: "110px",
                              height: "36px",
                              marginLeft: "450px",
                            }}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <RegularButton text="Submit" onClick={handleSubmit} type="submit" />
              </div>

            </div>
          </form>
        </ReusableModal>
        <ReusableTable
          fetchData={fetchGasData}
          columns={columns}
          showAction={true}
          showFooter={true}
          onDelete={handleOnDelete}
          onUpdate={handleOnUpdate}
          loading={loading}
          showEdit={false}
        />
      </div>
    </>
  );
}

export default GasInvoice;